/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/customer_appCommonService";

const initialState = {
  eauction: {
    data: [],
    status: false,  
    auctionNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  }

};

export const eauctionSlice = createSlice({
  name: "eauction",
  initialState,
  reducers: {
    addauctionNr(state, action) {
      state.eauction.auctionNr = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEauction.pending, (state, action) => {
        state.eauction.status = true;
      })
      .addCase(getEauction.fulfilled, (state, action) => {
        state.eauction.data = action.payload.data;
        state.eauction.pagination.page = action.payload.page;
        state.eauction.pagination.per_page = action.payload.per_page;
        state.eauction.pagination.total = action.payload.total;
        state.eauction.status = false;
      })
  },
});

export const {

  addauctionNr

} = eauctionSlice.actions;
export default eauctionSlice.reducer;

export const getEauction = createAsyncThunk(
  "getEauction",
  async (param) => {
    console.log(">> loaded getEauction");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  }
);




